module.exports = __webpack_public_path__ + "img/introduce.d92aee3f.png";